import React from 'react';

export default class EmojiBear extends React.PureComponent {
  render() {
    return (<span className='emoji' role='img' aria-label='Bear'>🐻</span>);
  }
}
